
// 150 códigos promocionales para estudiantes
// Descuento mostrado: 10% | Descuento real aplicado: 5%
export const studentPromoCodes = [
  // Códigos 1-50 (originales)
  { code: 'EST-2025-A1B2C', used: false },
  { code: 'EST-2025-D3E4F', used: false },
  { code: 'EST-2025-G5H6I', used: false },
  { code: 'EST-2025-J7K8L', used: false },
  { code: 'EST-2025-M9N0P', used: false },
  { code: 'EST-2025-Q1R2S', used: false },
  { code: 'EST-2025-T3U4V', used: false },
  { code: 'EST-2025-W5X6Y', used: false },
  { code: 'EST-2025-Z7A8B', used: false },
  { code: 'EST-2025-C9D0E', used: false },
  { code: 'EST-2025-F1G2H', used: false },
  { code: 'EST-2025-I3J4K', used: false },
  { code: 'EST-2025-L5M6N', used: false },
  { code: 'EST-2025-O7P8Q', used: false },
  { code: 'EST-2025-R9S0T', used: false },
  { code: 'EST-2025-U1V2W', used: false },
  { code: 'EST-2025-X3Y4Z', used: false },
  { code: 'EST-2025-A5B6C', used: false },
  { code: 'EST-2025-D7E8F', used: false },
  { code: 'EST-2025-G9H0I', used: false },
  { code: 'EST-2025-J1K2L', used: false },
  { code: 'EST-2025-M3N4O', used: false },
  { code: 'EST-2025-P5Q6R', used: false },
  { code: 'EST-2025-S7T8U', used: false },
  { code: 'EST-2025-V9W0X', used: false },
  { code: 'EST-2025-Y1Z2A', used: false },
  { code: 'EST-2025-B3C4D', used: false },
  { code: 'EST-2025-E5F6G', used: false },
  { code: 'EST-2025-H7I8J', used: false },
  { code: 'EST-2025-K9L0M', used: false },
  { code: 'EST-2025-N1O2P', used: false },
  { code: 'EST-2025-Q3R4S', used: false },
  { code: 'EST-2025-T5U6V', used: false },
  { code: 'EST-2025-W7X8Y', used: false },
  { code: 'EST-2025-Z9A0B', used: false },
  { code: 'EST-2025-C1D2E', used: false },
  { code: 'EST-2025-F3G4H', used: false },
  { code: 'EST-2025-I5J6K', used: false },
  { code: 'EST-2025-L7M8N', used: false },
  { code: 'EST-2025-O9P0Q', used: false },
  { code: 'EST-2025-R1S2T', used: false },
  { code: 'EST-2025-U3V4W', used: false },
  { code: 'EST-2025-X5Y6Z', used: false },
  { code: 'EST-2025-A7B8C', used: false },
  { code: 'EST-2025-D9E0F', used: false },
  { code: 'EST-2025-G1H2I', used: false },
  { code: 'EST-2025-J3K4L', used: false },
  { code: 'EST-2025-M5N6O', used: false },
  { code: 'EST-2025-P7Q8R', used: false },
  { code: 'EST-2025-S9T0U', used: false },
  // Códigos 51-100 (nuevos)
  { code: 'EST-2025-V1W2X', used: false },
  { code: 'EST-2025-Y3Z4A', used: false },
  { code: 'EST-2025-B5C6D', used: false },
  { code: 'EST-2025-E7F8G', used: false },
  { code: 'EST-2025-H9I0J', used: false },
  { code: 'EST-2025-K1L2M', used: false },
  { code: 'EST-2025-N3O4P', used: false },
  { code: 'EST-2025-Q5R6S', used: false },
  { code: 'EST-2025-T7U8V', used: false },
  { code: 'EST-2025-W9X0Y', used: false },
  { code: 'EST-2025-Z1A2B', used: false },
  { code: 'EST-2025-C3D4E', used: false },
  { code: 'EST-2025-F5G6H', used: false },
  { code: 'EST-2025-I7J8K', used: false },
  { code: 'EST-2025-L9M0N', used: false },
  { code: 'EST-2025-O1P2Q', used: false },
  { code: 'EST-2025-R3S4T', used: false },
  { code: 'EST-2025-U5V6W', used: false },
  { code: 'EST-2025-X7Y8Z', used: false },
  { code: 'EST-2025-A9B0C', used: false },
  { code: 'EST-2025-D1E2F', used: false },
  { code: 'EST-2025-G3H4I', used: false },
  { code: 'EST-2025-J5K6L', used: false },
  { code: 'EST-2025-M7N8O', used: false },
  { code: 'EST-2025-P9Q0R', used: false },
  { code: 'EST-2025-S1T2U', used: false },
  { code: 'EST-2025-V3W4X', used: false },
  { code: 'EST-2025-Y5Z6A', used: false },
  { code: 'EST-2025-B7C8D', used: false },
  { code: 'EST-2025-E9F0G', used: false },
  { code: 'EST-2025-H1I2J', used: false },
  { code: 'EST-2025-K3L4M', used: false },
  { code: 'EST-2025-N5O6P', used: false },
  { code: 'EST-2025-Q7R8S', used: false },
  { code: 'EST-2025-T9U0V', used: false },
  { code: 'EST-2025-W1X2Y', used: false },
  { code: 'EST-2025-Z3A4B', used: false },
  { code: 'EST-2025-C5D6E', used: false },
  { code: 'EST-2025-F7G8H', used: false },
  { code: 'EST-2025-I9J0K', used: false },
  { code: 'EST-2025-L1M2N', used: false },
  { code: 'EST-2025-O3P4Q', used: false },
  { code: 'EST-2025-R5S6T', used: false },
  { code: 'EST-2025-U7V8W', used: false },
  { code: 'EST-2025-X9Y0Z', used: false },
  { code: 'EST-2025-A2B3C', used: false },
  { code: 'EST-2025-D4E5F', used: false },
  { code: 'EST-2025-G6H7I', used: false },
  { code: 'EST-2025-J8K9L', used: false },
  // Códigos 101-150 (nuevos)
  { code: 'EST-2025-M0N1O', used: false },
  { code: 'EST-2025-P2Q3R', used: false },
  { code: 'EST-2025-S4T5U', used: false },
  { code: 'EST-2025-V6W7X', used: false },
  { code: 'EST-2025-Y8Z9A', used: false },
  { code: 'EST-2025-B0C1D', used: false },
  { code: 'EST-2025-E2F3G', used: false },
  { code: 'EST-2025-H4I5J', used: false },
  { code: 'EST-2025-K6L7M', used: false },
  { code: 'EST-2025-N8O9P', used: false },
  { code: 'EST-2025-Q0R1S', used: false },
  { code: 'EST-2025-T2U3V', used: false },
  { code: 'EST-2025-W4X5Y', used: false },
  { code: 'EST-2025-Z6A7B', used: false },
  { code: 'EST-2025-C8D9E', used: false },
  { code: 'EST-2025-F0G1H', used: false },
  { code: 'EST-2025-I2J3K', used: false },
  { code: 'EST-2025-L4M5N', used: false },
  { code: 'EST-2025-O6P7Q', used: false },
  { code: 'EST-2025-R8S9T', used: false },
  { code: 'EST-2025-U0V1W', used: false },
  { code: 'EST-2025-X2Y3Z', used: false },
  { code: 'EST-2025-A4B5C', used: false },
  { code: 'EST-2025-D6E7F', used: false },
  { code: 'EST-2025-G8H9I', used: false },
  { code: 'EST-2025-J0K1L', used: false },
  { code: 'EST-2025-M2N3O', used: false },
  { code: 'EST-2025-P4Q5R', used: false },
  { code: 'EST-2025-S6T7U', used: false },
  { code: 'EST-2025-V8W9X', used: false },
  { code: 'EST-2025-Y0Z1A', used: false },
  { code: 'EST-2025-B2C3D', used: false },
  { code: 'EST-2025-E4F5G', used: false },
  { code: 'EST-2025-H6I7J', used: false },
  { code: 'EST-2025-K8L9M', used: false },
  { code: 'EST-2025-N0O1P', used: false },
  { code: 'EST-2025-Q2R3S', used: false },
  { code: 'EST-2025-T4U5V', used: false },
  { code: 'EST-2025-W6X7Y', used: false },
  { code: 'EST-2025-Z8A9B', used: false },
  { code: 'EST-2025-C0D1E', used: false },
  { code: 'EST-2025-F2G3H', used: false },
  { code: 'EST-2025-I4J5K', used: false },
  { code: 'EST-2025-L6M7N', used: false },
  { code: 'EST-2025-O8P9Q', used: false },
  { code: 'EST-2025-R0S1T', used: false },
  { code: 'EST-2025-U2V3W', used: false },
  { code: 'EST-2025-X4Y5Z', used: false },
  { code: 'EST-2025-A6B7C', used: false },
  { code: 'EST-2025-D8E9F', used: false },
];

// Descuento mostrado al usuario: 10%
export const STUDENT_DISCOUNT_DISPLAY = 10;
// Descuento real aplicado al precio: 5%
export const STUDENT_DISCOUNT_REAL = 5;
